import { render, staticRenderFns } from "./registration-list.vue?vue&type=template&id=3be7b20a&scoped=true&"
import script from "./registration-list.vue?vue&type=script&lang=js&"
export * from "./registration-list.vue?vue&type=script&lang=js&"
import style0 from "./registration-list.vue?vue&type=style&index=0&id=3be7b20a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be7b20a",
  null
  
)

export default component.exports